"use client"; // Only for client-side components
import React from "react";
import Link from "next/link";
import "./FAQCategory.css";
import { topicsData } from "../data";
import {
  highlightText,
  getFilteredSubpages,
} from "@/app/helpers/getSearchResults";
import NeedSupport from "@/common/NeedSupport";
import ArrowRight from "@/assets/svgs/faqCategory/ArrowRight";
import SearchIcon from "@/assets/svgs/SearchIcon";
import ArrowRightQuestion from "@/assets/faqCategory/ArrowRightQuestion";
// import Image from "next/image";

function FAQCategory({ category }) {
  const activeTopic = topicsData.find((topic) => `/${category}` === topic.link);

  const Topsection = () => {
    const [searchTerm, setSearchTerm] = React.useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState("");

    React.useEffect(() => {
      const timer = setTimeout(() => {
        setDebouncedSearchTerm(searchTerm);
      }, 300);
      return () => clearTimeout(timer);
    }, [searchTerm]);

    const filteredSubpages = getFilteredSubpages(
      topicsData,
      debouncedSearchTerm
    );

    return (
      <div className="FAQ-c-top">
        <div className="FAQ-c-top-left">
          <Link href="/faq" className="FAQ-c-top-left-link">
            Hilfezentrum
          </Link>
          <ArrowRight className="FAQ-c-top-left-arrow-icon" />
          <Link href={`/faq/${category}`} className="FAQ-c-top-left-link">
            {activeTopic?.title}
          </Link>
        </div>
        <div className="FAQ-c-top-right">
          <div className="FAQ-input-wrapper">
            <input
              type="text"
              placeholder="Suche..."
              className="search-input transition"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon className="search-icon" />
          </div>
          {debouncedSearchTerm && (
            <div className="FAQCategory-results">
              {filteredSubpages.length > 0 ? (
                filteredSubpages.map((faq) => (
                  <Link
                    href={`/faq${faq.link}${faq.subpageLink}`}
                    key={`${faq.id}-${faq.link}-${faq.subpageLink}`}
                  >
                    <div className="FAQCategory-item transition">
                      <h2>{highlightText(faq.title, searchTerm)}</h2>
                      <p className="Search-result-text">
                        FAQ {" > "}
                        {faq.link.replace(/^\/+/, "")} {" > "}
                        {faq.subpageLink.replace(/^\/+/, "")}
                      </p>
                    </div>
                  </Link>
                ))
              ) : (
                <div className="FAQ-item">
                  <p>Keine Ergebnisse gefunden.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const FAQCategoryLeft = () => (
    <ul className="FAQ-c-left">
      {topicsData.map((topic) => {
        const isActive = `/${category}` === topic.link;
        return (
          <Link href={`/faq${topic.link}`} key={topic.id}>
            <li className="FAQ-c-left-item transition">
              {/* {isActive ? (
                <Image
                  src={topic.collectionIconActive}
                  className="FAQ-c-left-image"
                  alt={topic.title}
                />
              ) : (
                <Image
                  src={topic.collectionIcon}
                  className="FAQ-c-left-image"
                  alt={topic.title}
                />
              )} */}
              <p className={`${isActive ? "active" : ""}`}>{topic.title}</p>
            </li>
          </Link>
        );
      })}
    </ul>
  );

  const stripTags = (children) => {
    let textContent = "";

    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child)) {
        // If it's a valid element and has children, recursively process it
        if (child.props && child.props.children) {
          textContent += stripTags(child.props.children); // Concatenate text content from its children
        }
      } else if (typeof child === "string") {
        // If the child is a text node (string), add it to the textContent
        textContent += child;
      }
    });

    textContent = textContent.replace(/\.([^\s])/g, ". $1"); // Ensures space after period if no space exists

    return textContent; // Return the combined text content
  };

  const FAQCategoryRight = () => (
    <div className="FAQ-c-right">
      <h1>{activeTopic?.title}</h1>
      <ul className="FAQ-c-right-questions">
        {activeTopic?.subpages.map((question) => (
          <Link
            href={`/faq${activeTopic.link}${question.link}`}
            className="FAQ-c-right-link transition"
            key={question.id}
          >
            <li className="FAQ-c-right-question transition">
              <div className="FAQ-c-right-question-text">
                <h2>{question.title}</h2>
                <p>{stripTags(question.text)}</p>
              </div>
              <ArrowRightQuestion />
            </li>
          </Link>
        ))}
      </ul>
      <NeedSupport />
    </div>
  );

  return (
    <div className="FAQ-category">
      <div className="FAQ-category-wrapper">
        <Topsection />
        <div className="FAQ-category-main-wrapper">
          <FAQCategoryLeft />
          <FAQCategoryRight />
        </div>
      </div>
    </div>
  );
}

export default FAQCategory;
